export const ENVS = {
  development: {
    isDevelopment: true,
    name: 'development',
    apiUrl: 'https://api.dev.flixxo.com',
    webUrl: 'https://play.dev.flixxo.com',
    GA4_ID: 'G-WN94TPDQSZ',
    REDIRECT_URI: 'https://play.dev.flixxo.com/redirect',
    FACEBOOK_ID: '534304860310580',
  },
  staging: {
    isStaging: true,
    name: 'staging',
    apiUrl: 'https://api.stg.flixxo.com',
    webUrl: 'https://play.stg.flixxo.com',
    GA4_ID: 'G-66NMQEQS0L',
    REDIRECT_URI: 'https://play.stg.flixxo.com/redirect',
    FACEBOOK_ID: '534304860310580',
  },
  production: {
    isProduction: true,
    name: 'production',
    apiUrl: 'https://api.pro.flixxo.com',
    webUrl: 'https://play.flixxo.com',
    GA4_ID: 'G-CEWJKGYNVB',
    GTM_ID: 'GTM-W2ZG7KX',
    REDIRECT_URI: 'https://play.flixxo.com/redirect',
    FACEBOOK_ID: '534304860310580',
  }
}

export const environment = ENVS[process.env.REACT_APP_ENV]